import { render, staticRenderFns } from "./RevokeConsentRequestRootComponent.vue?vue&type=template&id=17cdd690"
import script from "./RevokeConsentRequestRootComponent.vue?vue&type=script&lang=js"
export * from "./RevokeConsentRequestRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports